/**
 * Classe que cria e gerencia os filtros na tela
 * @author: Adalto Junior
 *
 */


Greenmile.HoursOfService = Greenmile.HoursOfService || {};

Greenmile.HoursOfService.Filter = function () {

    var validateForm = function () {

        var error = null;

        try {

            var validation    = null,
                errorMessages,
                dateValidator = new Monet.Date.GeneralFunctions(),
                form          = App.Forms.HOS.form,
                beginDate     = form.fields.beginDate.getValue(),
                endDate       = form.fields.endDate.getValue();

            var iniMili, endMili;

            var appendErrorMessage = function (resource) {
                errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(resource));
            };

            validation = form.validate();
            errorMessages = validation.errorMessages || [];

            if (errorMessages.length === 0) {

                if (dateValidator.validateIfDateIsInFuture(endDate)) {

                    appendErrorMessage('HOSMap.errorMessage.endDateIsInFuture');

                }

                iniMili = new Date(beginDate).getTime();
                endMili = new Date(endDate).getTime();

                //valida se a data inicial é maior que a final.
                if (iniMili > endMili) {

                    appendErrorMessage('HOSMap.errorMessage.beginDateIsGreather');

                }

                if (errorMessages.length > 0) {
                    validation.status = false;
                }

            }

            return validation;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on validate form.", e);
            error.console();

        }
    };

    var clearMessageError = function () {

        var selector = "#HosMapDisplay .monetInlineAlerContainer",
            element  = document.querySelector(selector);

        if (element !== null) {
            element.innerHTML = "";
        }
    };

    this.createFilter = function () {

        var error = null;

        try {
            var form = new Monet.Builder.Form.Vertical(App.Forms.HOS.layout.show, 'HOS');
            App.Forms.HOS.form = form;

            var sectionFilter = document.querySelector("#form_HOSMaps");
            sectionFilter.appendChild(form.render());

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "No generate filter to hos map.");
            error.console();
        }

    };

    this.sendForm = function () {

        var error = null;

        try {

            var allowSubmit = validateForm(),
                filter      = null,
                hosRequests = null,
                callback    = null;

            if (allowSubmit.status) {

                clearMessageError();

                filter = App.Forms.HOS.form.getValues();
                hosRequests = new Greenmile.HoursOfService.Requests();

                callback = function (hosCollection) {

                    var hosMapEvents = App.Views.HOSMaps,
                        map          = Monet.Session.HOS.map;

                    Monet.Session.HOS.listHos = hosCollection;

                    if (map !== null) {

                        hosMapEvents.drawMarkersFromSearchByDriver(hosCollection, map);

                    }

                    hosMapEvents.showLogBook(hosCollection);

                };

                hosRequests.getHosByDriver(filter, callback);


            } else {

                var monetMessage = new Monet.Form.Messages.InlineMessage();

                monetMessage.setScope("#HosMapDisplay");
                monetMessage.setInfoType("error");
                monetMessage.setMessage(allowSubmit);

                monetMessage.triggerMessage();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on send form hos maps.", e);
            error.console();

        }

    };
};
